module.exports = __webpack_public_path__ + "static/media/demo25Small.6e68f3d0.mp4";